import axios from 'axios'
// import Vuetify from 'vuetify'

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		clientiIds: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		praticaTagsIds: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		contrattoDiServizioTagsIds: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		esitoClickDay: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		regioni: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		assiDiFinanziamentoIds: {
			default: null,
			valueNonApplied: null,
			value: null
		},
		idsStatiFasi: {
			id_stato_fase_1: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_2: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_3: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_4: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_5: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_6: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_7: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_8: {
				default: null,
				valueNonApplied: null,
				value: null
			},
			id_stato_fase_9: {
				default: null,
				valueNonApplied: null,
				value: null
			}
		}
	},

	getters: {
		defaultFilters(state) {
			let defaultFilters = {};
			for (let stateKey in state) {
				defaultFilters[stateKey] = state[stateKey].default;
			}
			return defaultFilters;
		},
		appliedFilters(state) {
			let appliedFilters = {};
			for (let stateKey in state) {
				if (stateKey == 'idsStatiFasi') {
					appliedFilters.idsStatiFasi = {};
					for (const idsStatiFasiKey in state[stateKey]) {
						appliedFilters.idsStatiFasi[idsStatiFasiKey] = state[stateKey][idsStatiFasiKey].value;
					}
				}
				else {
					appliedFilters[stateKey] = state[stateKey].value;
				}
				
			}
			return appliedFilters;
		},
		thereAreFiltersApplied(state) {
			let thereAreFiltersApplied = false;
			for (let stateKey in state) {
				if (stateKey == 'idsStatiFasi') {
					for (const idsStatiFasiKey in state[stateKey]) {
						if (state[stateKey][idsStatiFasiKey].value != state[stateKey][idsStatiFasiKey].default) {
							thereAreFiltersApplied = true;
						}
					}
				}
				else if (state[stateKey].value != state[stateKey].default) {
					thereAreFiltersApplied = true;
				}
			}
			return thereAreFiltersApplied;
		},
		
		clientiIds(state) {
			return state.clientiIds;
		},
		praticaTagsIds(state) {
			return state.praticaTagsIds;
		},
		contrattoDiServizioTagsIds(state) {
			return state.contrattoDiServizioTagsIds;
		},
		esitoClickDay(state) {
			return state.esitoClickDay;
		},
		regioni(state) {
			return state.regioni;
		},
		assiDiFinanziamentoIds(state) {
			return state.assiDiFinanziamentoIds;
		},
		idsStatiFasi(state) {
			return state.idsStatiFasi;
		}
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_CLIENTI_IDS_NON_APPLIED (state, value) {
			state.clientiIds.valueNonApplied = value;
		},
		SET_CLIENTI_IDS_TO_DEFAULT (state, value) {
			state.clientiIds.valueNonApplied = state.clientiIds.default;
			state.clientiIds.value = state.clientiIds.default;
		},
		SET_PRATICA_TAGS_IDS_NON_APPLIED (state, value) {
			state.praticaTagsIds.valueNonApplied = value;
		},
		SET_CONTRATTO_DI_SERVIZIO_TAGS_IDS_NON_APPLIED (state, value) {
			state.contrattoDiServizioTagsIds.valueNonApplied = value;
		},
		SET_ESITO_CLICK_DAY_NON_APPLIED (state, value) {
			state.esitoClickDay.valueNonApplied = value;
		},
		SET_REGIONI_NON_APPLIED (state, value) {
			state.regioni.valueNonApplied = value;
		},
		SET_ASSI_DI_FINANZIAMENTO_IDS_NON_APPLIED (state, value) {
			state.assiDiFinanziamentoIds.valueNonApplied = value;
		},
		SET_ID_STATO_FASE_NOT_APPLIED(state, payload) {
			state.idsStatiFasi[`id_stato_fase_${payload.ordinamento}`].valueNonApplied = payload.id;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		applyFilters({ state }) {
			for (let stateKey in state) {
				if (stateKey == 'idsStatiFasi') {
					for (const idsStatiFasiKey in state[stateKey]) {
						state[stateKey][idsStatiFasiKey].value = state[stateKey][idsStatiFasiKey].valueNonApplied;
					}
				}
				else {
					state[stateKey].value = state[stateKey].valueNonApplied;
				}
			}
		},
		resetFilters({ state }) {
			for (let stateKey in state) {
				if (stateKey == 'idsStatiFasi') {
					for (const idsStatiFasiKey in state[stateKey]) {
						state[stateKey][idsStatiFasiKey].value = state[stateKey][idsStatiFasiKey].default;
						state[stateKey][idsStatiFasiKey].valueNonApplied = state[stateKey][idsStatiFasiKey].default;
					}
				}
				else {
					state[stateKey].value = state[stateKey].default;
					state[stateKey].valueNonApplied = state[stateKey].default;
				}
			}
		}
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }